module.exports = __webpack_public_path__ + "img/Familiengrinsen.3c053977.svg";